var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui-snackbar"},[_c('div',{staticClass:"ui-snackbar-text"},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }